import React from 'react';
import TextField from '@material-ui/core/TextField';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import NumberFormat from 'react-number-format';
import _ from 'lodash';

export const renderTextField = ({
  input,
  label,
  meta: { touched, error },
  ...custom
}) => {
  return (
    <TextField
      label={label}
      error={!!(touched && error)}
      helperText={touched && error}
      margin='dense'
      fullWidth
      {...input}
      {...custom}
    />
  );
}

export const renderNumberField = ({
  input, label
}) => {
  return (
    <TextField
      label={label}
      {...input}
      InputProps={{
        inputComponent: NumberFormatCustom,
      }}
    />
  );
}

export const requiredValidator = (value) => {
  return _.isNil(value) ? 'required' : undefined;
}

export const industrySelect = ({name, options, input, label}) => {
  const customLabel = `Industry (${derivedIndustry(input.value)})`
  return renderSelect({name, options, input, label: customLabel})
}

export const renderSelect = ({name, options, input, label}) => {
  return (
    <FormControl style={{display: 'flex'}}>
      <InputLabel htmlFor={name}>{label}</InputLabel>
      <Select
        inputProps={{
          name: name,
          id: name,
        }}
        {...input}
      >
        {options.map(option => <MenuItem key={`${name}-${option}`} value={option}>{_.startCase(option)}</MenuItem>)}
      </Select>
    </FormControl>
  );
}

export const renderReferralSelect = ({name, options, input, label}) => {
  return (
    <FormControl style={{display: 'flex'}}>
      <InputLabel htmlFor={name}>{label}</InputLabel>
      <Select
        inputProps={{
          name: name,
          id: name,
        }}
        {...input}
      >
        {options && options.map(option =>
          <MenuItem key={option.id} value={option.id}>
            {option.fullName}
          </MenuItem>
        )}
      </Select>
    </FormControl>
  );
}

const sanitizeInputValue = (input) => {
  if (!_.isUndefined(input.value)) {
    input['value'] = input.value.toString();
  }
  return input;
}

export const renderRadioGroup = ({name, input, options, label}) => {
  input =  sanitizeInputValue(input)
  return (
    <FormControl style={{display: 'flex'}}>
      <FormLabel component="legend">{label}</FormLabel>
      <RadioGroup
        aria-label={name}
        name={name}
        {...input}
        style={{flexDirection: 'row'}}
      >
        {options.map(option => <FormControlLabel key={`${name}-${option.value}`} value={option.value.toString()} control={<Radio />} label={option.key} />)}
      </RadioGroup>
    </FormControl>
  );
}
const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
});

const datePicker = (props) => {
  const { classes } = props;
  const formattedDate = moment(props.input.value).format('YYYY-MM-DD')
  return (
    <form className={classes.container} noValidate>
      <TextField
        {...props.input}
        id={props.input.name}
        label={props.label}
        validate={props.validate}
        type="date"
        value={formattedDate}
        className={classes.textField}
        InputLabelProps={{
          shrink: true,
        }}
      />
    </form>
  );
}

export const renderDatePicker = withStyles(styles)(datePicker);

const NumberFormatCustom = (props) => {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      ref={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      thousandSeparator
      prefix="$"
    />
  );
}

const PREFERRED = [
  'Accommodation - B&B, Hotel, Motel', 'Accounting', 'Cafes and Restaurants', 'Catering Services', 'Chemists and Pharmacies',
  'Dental Services', 'Electrical Services', 'Flower Retailing', 'Garden Supplies and Retailing', 'General Medical Practitioners and Specialists',
  'Hairdressing and Beauty Services', 'Hardware and Building Supplies', 'Health/Fitness Centres and Gyms', 'Legal Services',
  'Newsagencies', 'Optometry and Optical Services', 'Painting and Decorating Services', 'Pathology and Diagnostic Imaging',
  'Plumbing Services', 'Pubs, Taverns and Bars', 'Takeaway Food', 'Veterinary Services', 'Watch and Jewellery Retailing'
]
const ACCEPTED = [
  'Advertising Agencies', 'Aged Residential Care', 'Architects', 'Book Retailing', 'Building and Other Industrial Cleaning',
  'Building Pest Control', 'Commercial Contractors', 'Courier Pick Up and Delivery', 'Employment, Recruitment and Labour Hire',
  'Engineering Design and Consulting', 'Equipment Hire', 'Financial Broking Services', 'Fire and Security Alarm', 'Floor Coverings Retailing',
  'Fruit and Vegetable Retailing', 'Gardening and Landscape Services', 'Glaziers', 'Housewares Retailing', 'Solar, Heating, Ventilation and Air Condition Services',
  'Installation Services', 'Liquor Retailing', 'Motor Mechanics and Workshops', 'Marine Equipment Retailing', 'Other Building Installation Services',
  'Other General Services', 'Petrol Stations', 'Physiotheraphy, Chiropratic and Oesteopathic Services', 'Professional Photography',
  'Real Estate Services', 'Residential and Commercial Property Operators', 'Sports and Physical Education and Instruction',
  'Supermarkets', 'Transport and Haulage', 'Travel Agencies', 'Wheel and Tyre Sales'
]
const NOT_ACCEPTED = [
  'Adult Related Indstries', 'Auction Houses', 'Direct Marketing', 'Event and Entertainment Sales', 'Firearm Dealers',
  'Freight Forwarders and Customs Cleaning Houses', 'Glass Tinting', 'Panel-beaters and Smash Repairers', 'Property Developers',
  'Taxi and Hire Cars', 'Towing Services', 'Used Vehicle Dealerships'
]

export const INDUSTRIES = PREFERRED.concat(ACCEPTED).concat(NOT_ACCEPTED);

const derivedIndustry = industry => {
  if (PREFERRED.includes(industry)) {
    return 'preferred';
  } else if (ACCEPTED.includes(industry)) {
    return 'accepted';
  } else if (NOT_ACCEPTED.includes(industry)) {
    return 'not_accepted';
  }
}



// WEBPACK FOOTER //
// ./src/utils/formHelper.js